import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="relative w-full bg-background-900 text-background-50 py-14 md:py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold mb-3">CSSBuy Spreadsheet</h3>
            <p className="text-sm text-background-50/65 leading-relaxed mb-4">
              Guia independente e informativo sobre CSSBuy Spreadsheet. Não vendemos produtos diretamente. Recomendamos sempre verificar fornecedores antes de comprar.
            </p>
            <div className="flex items-center gap-3">
              {["ri-twitter-x-line", "ri-instagram-line", "ri-youtube-line", "ri-github-line"].map((icon, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="w-8 h-8 rounded-full border border-background-50/25 flex items-center justify-center hover:bg-background-50/10 hover:border-background-50/40 transition-all cursor-pointer"
                  aria-label={`Social ${idx + 1}`}
                >
                  <i className={`${icon} text-sm text-background-50/60`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">Links Úteis</h4>
            <div className="space-y-2.5">
              <a href="#categories" className="block text-sm text-background-50/65 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                {t("sectionCategories")}
              </a>
              <a href="#comparison" className="block text-sm text-background-50/65 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                Comparação de Produtos
              </a>
              <a href="#faq" className="block text-sm text-background-50/65 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                {t("sectionFAQ")}
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-background-50/65 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Kaspreadsheet.com <i className="ri-external-link-line text-xs ml-1"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/40 mb-4">Categorias Populares</h4>
            <div className="grid grid-cols-2 gap-2.5">
              {["Calçados", "Moletons", "Camisetas", "Jaquetas", "Bolsas", "Acessórios"].map((cat, idx) => (
                <a
                  key={idx}
                  href="#categories"
                  className="text-sm text-background-50/65 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">{t("footerRights")}</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              {t("footerTerms")}
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              {t("footerPrivacy")}
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">
              {t("footerContact")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}